// extracted by mini-css-extract-plugin
module.exports = {"cityList":"citySlug_cityList__3E2iK"};